import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink py-9" data-id="element-102" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-103" data-mp="3geze367ujv27">
        <p className="font-display text-lg tracking-[0.18em] text-ivory" data-id="element-104" data-mp="3ggk7utmc79z0">
          THE ART FLOW <span className="text-gold" data-id="element-105" data-mp="32pfh6h0y5s0t">ARCHIVE™</span>
        </p>
        <p className="mt-4 font-display text-base tracking-[0.22em] text-ivory/75" data-id="element-106" data-mp="36oo87e4lrbso">
          PLAN · TEACH · CREATE
        </p>
        <div className="mx-auto mt-7 h-px w-16 bg-gold/50" aria-hidden="true" data-id="element-107" data-mp="3ugboz385h6h8" />
        <p className="mt-7 font-sans text-xs leading-relaxed text-ivory/80" data-id="element-108" data-mp="37o6cv1anxdd">
          © 2026 THE ART FLOW ARCHIVE™ — All rights reserved.
        </p>
        <p className="mx-auto mt-2 max-w-xl font-sans text-[11px] leading-relaxed text-ivory/70" data-id="element-109" data-mp="3lgooqkr5q6pr">
          This digital product is designed for art teachers seeking to improve
          their classroom planning and teaching efficiency. Built for art
          educators who deserve better tools.
        </p>
      </div>
    </footer>;
}